import React from 'react';
import { NavLink } from 'react-router-dom';
import { changeLanguage } from 'i18next';
import { useTranslation } from 'react-i18next';

import { LANGUAGES } from '../../constants/index';

import './SubMenu.css';
import config from '../../config';

function SubMenu() {
  const { t } = useTranslation();

  const setLanguageLocaly = (language) => {
    changeLanguage(language);
    localStorage.setItem("selectedLanguage", language);
  }

  return (
    <div className="submenu">
      <div className="container">
        <div className='columns'>
          <div className='column'>
            {config.isLive && <nav className="navbar-start">
              <NavLink exact to="/browse-trips" className="navbar-item submenu-item">
                {t("FIND_TRIPS")}
              </NavLink>
              <NavLink
                exact
                to="/browse-agents"
                className="navbar-item submenu-item"
              >
                {t("FIND_AGENTS")}
              </NavLink>
            </nav>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubMenu;
